import { render, staticRenderFns } from "./AddTipoAlterno.vue?vue&type=template&id=387fdf0a&"
import script from "./AddTipoAlterno.vue?vue&type=script&lang=js&"
export * from "./AddTipoAlterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports